import { useMatchRoute, useRouterState } from "@tanstack/react-router"
import type {
  RegisteredRouter,
  UseMatchRouteOptions,
} from "@tanstack/react-router"

/**
 * Whether the given route is currently matched. Use it instead of
 * `useMatchRoute`, which the React Compiler breaks.
 *
 * `useMatchRoute`'s callback keeps one identity but reads the location
 * internally, so the compiler caches `matchRoute(…)` against the callback
 * alone and the answer freezes at first mount. Inside a `useRouterState`
 * selector the answer is a hook return value, which the compiler doesn't
 * cache, and it updates on navigation.
 */
export default function useIsRouteActive<
  const TFrom extends string = string,
  const TTo extends string | undefined = undefined,
  const TMaskFrom extends string = TFrom,
  const TMaskTo extends string = "",
>(
  opts: UseMatchRouteOptions<RegisteredRouter, TFrom, TTo, TMaskFrom, TMaskTo>,
): boolean {
  const matchRoute = useMatchRoute()

  return useRouterState({ select: () => !!matchRoute(opts) })
}
